import { render, staticRenderFns } from "./DocumentOkIcon.vue?vue&type=template&id=78688607"
import script from "./DocumentOkIcon.vue?vue&type=script&lang=js"
export * from "./DocumentOkIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports